// Transfer market 2.0 — constante comune (aceleasi valori ca pe victorycup.ro/transfer-market)

export const SITE_URL = 'https://victorycup.ro';
export const SITE_HOST = 'victorycup.ro';
export const PRIVACY_POLICY_HREF = `${SITE_URL}/politica-de-confidentialitate`;

export const MIN_SQUAD = 10;
export const MAX_SQUAD = 20;

export const ALL = 'all';
export const allOption = {value: ALL, label: 'Toate'};

export type TmTabKey = 'forming' | 'teams' | 'players' | 'free' | 'new' | 'mine';

export const TABS: {key: TmTabKey, label: string}[] = [
	{key: 'forming', label: 'Echipe în formare'},
	{key: 'teams', label: 'Echipe caută jucători'},
	{key: 'players', label: 'Jucători caută echipă'},
	{key: 'free', label: 'Jucători liberi'},
	{key: 'new', label: 'Jucători noi'},
	{key: 'mine', label: 'Contul meu'},
];

export const COMPETITIONS = [
	{value: 'Victory Cup', label: 'Victory Cup'},
	{value: 'Old Boys', label: 'Old Boys'},
];

export const LEAGUES = [
	{value: 'Liga 1', label: 'Liga 1'},
	{value: 'Liga 2', label: 'Liga 2'},
	{value: 'Liga 3', label: 'Liga 3'},
	{value: 'Liga 4', label: 'Liga 4'},
];

export const POSITION_NAMES = ['Portar', 'Fundaș', 'Mijlocaș', 'Atacant'];
export const POSITIONS = POSITION_NAMES.map(p => ({value: p, label: p}));

export const AGES = [
	{value: '18-25', label: '18 – 25 ani'},
	{value: '25-35', label: '25 – 35 ani'},
	{value: '35-45', label: '35 – 45 ani'},
	{value: '45+', label: 'Peste 45 ani'},
];

export const MATCHES = [
	{value: 'sub10', label: 'Sub 10'},
	{value: '10-30', label: 'Între 10 și 30'},
	{value: '30-50', label: 'Între 30 și 50'},
	{value: '50+', label: 'Peste 50'},
];

export const COSTS = [
	{value: 'shared', label: 'Împărțim costurile'},
	{value: 'free', label: 'Joacă gratis'},
];

export const SQUAD_FILTERS = [
	{value: 'almost', label: 'Aproape complete'},
	{value: 'forming', label: 'În formare'},
	{value: 'complete', label: 'Complete'},
];

export const SHOW_FILTERS = [
	{value: ALL, label: 'Activi'},
	{value: 'recent', label: 'Activi recent'},
	{value: 'inactive', label: 'Și inactivii'},
];

export const PLAYER_STATUS: Record<string, {label: string, badge: string, dot?: boolean}> = {
	seeking: {label: 'Caută echipă', badge: 'green', dot: true},
	recent: {label: 'Activ recent', badge: 'amber'},
	inactive: {label: 'Inactiv', badge: 'grey'},
};

export const SKILLS = ['Viteză', 'Finalizare', 'Dribling', 'Pase', 'Reflexe', 'Joc aerian', 'Rezistență', 'Marcaj'];
export const WANTED_LEVELS = ['Liga 1', 'Liga 2', 'Liga 3', 'Liga 4', 'Nu știu'];
export const TEAM_LEVELS = ['Liga 1', 'Liga 2', 'Liga 3', 'Liga 4', 'Nu știm încă'];
export const TEAM_SIZES = ['1 (doar eu)', '2–4', '5–7', '8–9'];
export const AD_AGES = ['18–25', '18–35', '25–35', '35+', 'orice'];

export const HOW_IT_WORKS = [
	{title: 'Creezi echipa', text: 'Nume provizoriu, competiția (Victory Cup / Old Boys), liga dorită.'},
	{title: 'O completezi', text: 'Link WhatsApp pentru prieteni + cereri de la jucătorii liberi.'},
	{title: 'Ajungi la 10', text: 'Butonul „Înscrie oficial” se deschide.'},
	{title: 'Joci la Royal Arena', text: 'Contract, taxă, legitimare — fluxul existent.'},
];

export const REJECT_REASONS = ['Fața nu se vede', 'Mai multe persoane', 'Nu e fotbal', 'Conținut nepotrivit', 'Logo / reclamă', 'Clip peste 60 sec', 'Link mort'];

export const AVATAR_COLORS = ['#2A2A30', '#B8102A', '#4C4C55', '#146B38', '#3A2E8C', '#1E8E4A'];
